import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { valdiatePage } from '../../global';
import Bulkaddresslabel from './bulkaddresslabel';
// import Grid from './grid';
import '../bulkbooking/bulkbooking.css'
import UploadStatus from '../bulkbooking/uploadstatus';

const BulkLabel = () => {
    const state = useSelector(state => { return { appData: state.appData, bulkBookingData: state.bulkBookingData } });
    const { userInfo } = state.appData;
    const { gridStatus } = state.bulkBookingData;

    const history = useHistory();

    const myWorker = React.useRef(new Worker('./trackingbulkwebworker.js'));
    let worker = myWorker.current;
    useEffect(() => {
        if (!worker) {
            worker = new Worker('./trackingbulkwebworker.js')
        }
        return () => {
            worker.terminate();
            worker = null;
        }
    }, [])

    // useEffect(() => {
    //     if (!valdiatePage('/bulklabel')) {
    //         history.push('/login');
    //     }
    // }, []);

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Bulk Address Label</h1>
        </div>
        <div className="card sticky" style={{ padding: 10 }}>
            <Bulkaddresslabel myWorker={worker} />
            {/* {grid && grid.length > 0 && <Grid />} */}
            {gridStatus && gridStatus.length > 0 && (
                <UploadStatus data={gridStatus} />
            )}
        </div>
    </section>
}

export default BulkLabel;